<template>
  <div class>
    <div class="row mb5">
      <div class="col-md-4"></div>
      <div class="col col-md-2">
        <label class="form-control-label">High Competitive Adv. Benchmark</label>
      </div>
      <div class="col col-md-2">
        <label class="form-control-label">Some Competitive Adv. Benchmark</label>
      </div>
      <div class="col col-md-2">
        <label class="form-control-label">Highly Competitive Benchmark</label>
      </div>
      <div class="col col-md-2">
        <label class="form-control-label">Fiercely Competitive Benchmark</label>
      </div>
    </div>
    <div class="row mb5">
      <div class="col-md-12">
        <form @onsubmit.prevent action>
          <div
            v-for="(field, index) in fields"
            v-bind:key="index"
            class="row"
            style="margin-bottom: 10px;"
          >
            <div class="col-md-4">
              <label :for="field.name" class="form-control-label">{{field.label}}</label>
            </div>
            <div class="col col-md-2">
              <input
                :type="field.type"
                v-model="formData[field.name+'_high_competative_advantage_benchmark']"
                :id="field.name"
                placeholder="Enter High Competitive Adv. Benchmark"
                class="form-control"
              />
              <!-- <small v-if="errors[field.name].value" class="form-text text-danger">{{errors[field.name].value}}</small> -->
            </div>
            <div class="col col-md-2">
              <input
                :type="field.type"
                v-model="formData[field.name+'_some_competative_advantage_benchmark']"
                :id="field.name"
                placeholder="Enter Some Competitive Adv. Benchmark"
                class="form-control"
              />
              <!-- <small v-if="errors[field.name].source" class="form-text text-danger">{{errors[field.name].source}}</small> -->
            </div>
            <div class="col col-md-2">
              <input
                :type="field.type"
                v-model="formData[field.name+'_highly_competative_benchmark']"
                :id="field.name"
                placeholder="Enter Highly Competitive Benchmark"
                class="form-control"
              />
              <!-- <small v-if="errors[field.name].source" class="form-text text-danger">{{errors[field.name].source}}</small> -->
            </div>
            <div class="col col-md-2">
              <input
                :type="field.type"
                v-model="formData[field.name+'_fiercely_competative_benchmark']"
                :id="field.name"
                placeholder="Enter Fiercely Competitive Benchmark"
                class="form-control"
              />
              <!-- <small v-if="errors[field.name].source" class="form-text text-danger">{{errors[field.name].source}}</small> -->
            </div>
          </div>
          <div class="form-group pull-right">
            <!-- <submitButton @click.prevent="submitGlobalForm" type="submit" class="btn btn-info">Submit</submitButton> -->
            <button @click="save" type="button" class="btn btn-primary">Save & Run as per daily cron</button>
            <button
              @click="update"
              type="button"
              class="btn btn-primary"
            >Save & Run cron immediately</button>
          </div>
        </form>
      </div>
      <PinCheck
        :show.sync="show"
        ref="smallModal"
        v-bind:small="true"
        @submitForm="submitForm"
        :cancelClass="'btn btn-secondary'"
      ></PinCheck>
    </div>
  </div>
</template>
<script>
import http from "@/lib/http";
// import { formCommonMixins } from "../../assets/mixins/formcommon.js";
import PinCheck from "@/components/PinCheck.vue";
export default {
  components: { PinCheck },
  // mixins: [formCommonMixins],
  created() {
    this.getFormData();
    // this.setData();
    // this.setFormData();
  },
  data() {
    return {
      show: false,
      pin: "",
      curDate: new Date(),
      globalData: {
        avg_ebitDA_per_sales: {
          high_competative_advantage_benchmark: "",
          some_competative_advantage_benchmark: "",
          highly_competative_benchmark: "",
          fiercely_competative_benchmark: ""
        },
        avg_research_development_costs_per_sales: {
          high_competative_advantage_benchmark: "",
          some_competative_advantage_benchmark: "",
          highly_competative_benchmark: "",
          fiercely_competative_benchmark: ""
        },
        avg_interest_per_sales: {
          high_competative_advantage_benchmark: "",
          some_competative_advantage_benchmark: "",
          highly_competative_benchmark: "",
          fiercely_competative_benchmark: ""
        },
        avg_depreciation_per_sales: {
          high_competative_advantage_benchmark: "",
          some_competative_advantage_benchmark: "",
          highly_competative_benchmark: "",
          fiercely_competative_benchmark: ""
        },
        avg_selling_n_administration_per_ns: {
          high_competative_advantage_benchmark: "",
          some_competative_advantage_benchmark: "",
          highly_competative_benchmark: "",
          fiercely_competative_benchmark: ""
        },
        avg_capex_per_net_profit: {
          high_competative_advantage_benchmark: "",
          some_competative_advantage_benchmark: "",
          highly_competative_benchmark: "",
          fiercely_competative_benchmark: ""
        },
        avg_net_profit_per_sales: {
          high_competative_advantage_benchmark: "",
          some_competative_advantage_benchmark: "",
          highly_competative_benchmark: "",
          fiercely_competative_benchmark: ""
        },
        number_of_time_sign_change_eps: {
          high_competative_advantage_benchmark: "",
          some_competative_advantage_benchmark: "",
          highly_competative_benchmark: "",
          fiercely_competative_benchmark: ""
        },
        number_of_time_sign_change_cash_eps: {
          high_competative_advantage_benchmark: "",
          some_competative_advantage_benchmark: "",
          highly_competative_benchmark: "",
          fiercely_competative_benchmark: ""
        }
      },
      fields: [
        {
          label: "EBITDA Per Sales",
          name: "avg_ebitDA_per_sales",
          type: "text",
          reletedField: [
            {
              label: "high_competative_advantage_benchmark",
              placeholder: "Enter High competitive Adv.",
              name: "high_competative_advantage_benchmark",
              type: "text",
              value: ""
            },
            {
              label: "some_competative_advantage_benchmark",
              placeholder: "Enter Some Competitive Adv.",
              name: "some_competative_advantage_benchmark",
              type: "text",
              value: ""
            },
            {
              label: "highly_competative_benchmark",
              placeholder: "Enter Highly Competitive",
              name: "highly_competative_benchmark",
              type: "text",
              value: ""
            },
            {
              label: "fiercely_competative_benchmark",
              placeholder: "Enter Fiercely Competitive",
              name: "fiercely_competative_benchmark",
              type: "text",
              value: ""
            }
          ]
        },
        {
          label: "Research and Development costs per Sales",
          name: "avg_research_development_costs_per_sales",
          type: "text",
          reletedField: [
            {
              label: "high_competative_advantage_benchmark",
              placeholder: "Enter High competitive Adv.",
              name: "high_competative_advantage_benchmark",
              type: "text",
              value: ""
            },
            {
              label: "some_competative_advantage_benchmark",
              placeholder: "Enter Some Competitive Adv.",
              name: "some_competative_advantage_benchmark",
              type: "text",
              value: ""
            },
            {
              label: "highly_competative_benchmark",
              placeholder: "Enter Highly Competitive",
              name: "highly_competative_benchmark",
              type: "text",
              value: ""
            },
            {
              label: "fiercely_competative_benchmark",
              placeholder: "Enter Fiercely Competitive",
              name: "fiercely_competative_benchmark",
              type: "text",
              value: ""
            }
          ]
        },
        {
          label: "Interest per Sales",
          name: "avg_interest_per_sales",
          type: "text",
          reletedField: [
            {
              label: "high_competative_advantage_benchmark",
              placeholder: "Enter High competitive Adv.",
              name: "high_competative_advantage_benchmark",
              type: "text",
              value: ""
            },
            {
              label: "some_competative_advantage_benchmark",
              placeholder: "Enter Some Competitive Adv.",
              name: "some_competative_advantage_benchmark",
              type: "text",
              value: ""
            },
            {
              label: "highly_competative_benchmark",
              placeholder: "Enter Highly Competitive",
              name: "highly_competative_benchmark",
              type: "text",
              value: ""
            },
            {
              label: "fiercely_competative_benchmark",
              placeholder: "Enter Fiercely Competitive",
              name: "fiercely_competative_benchmark",
              type: "text",
              value: ""
            }
          ]
        },
        {
          label: "Depreciation per Sales",
          name: "avg_depreciation_per_sales",
          type: "text",
          reletedField: [
            {
              label: "high_competative_advantage_benchmark",
              placeholder: "Enter High competitive Adv.",
              name: "high_competative_advantage_benchmark",
              type: "text",
              value: ""
            },
            {
              label: "some_competative_advantage_benchmark",
              placeholder: "Enter Some Competitive Adv.",
              name: "some_competative_advantage_benchmark",
              type: "text",
              value: ""
            },
            {
              label: "highly_competative_benchmark",
              placeholder: "Enter Highly Competitive",
              name: "highly_competative_benchmark",
              type: "text",
              value: ""
            },
            {
              label: "fiercely_competative_benchmark",
              placeholder: "Enter Fiercely Competitive",
              name: "fiercely_competative_benchmark",
              type: "text",
              value: ""
            }
          ]
        },
        {
          label: "Selling and Administration per Sales",
          name: "avg_selling_n_administration_per_ns",
          type: "text",
          reletedField: [
            {
              label: "high_competative_advantage_benchmark",
              placeholder: "Enter High competitive Adv.",
              name: "high_competative_advantage_benchmark",
              type: "text",
              value: ""
            },
            {
              label: "some_competative_advantage_benchmark",
              placeholder: "Enter Some Competitive Adv.",
              name: "some_competative_advantage_benchmark",
              type: "text",
              value: ""
            },
            {
              label: "highly_competative_benchmark",
              placeholder: "Enter Highly Competitive",
              name: "highly_competative_benchmark",
              type: "text",
              value: ""
            },
            {
              label: "fiercely_competative_benchmark",
              placeholder: "Enter Fiercely Competitive",
              name: "fiercely_competative_benchmark",
              type: "text",
              value: ""
            }
          ]
        },
        {
          label: "Capex per Net Profit",
          name: "avg_capex_per_net_profit",
          type: "text",
          reletedField: [
            {
              label: "high_competative_advantage_benchmark",
              placeholder: "Enter High competitive Adv.",
              name: "high_competative_advantage_benchmark",
              type: "text",
              value: ""
            },
            {
              label: "some_competative_advantage_benchmark",
              placeholder: "Enter Some Competitive Adv.",
              name: "some_competative_advantage_benchmark",
              type: "text",
              value: ""
            },
            {
              label: "highly_competative_benchmark",
              placeholder: "Enter Highly Competitive",
              name: "highly_competative_benchmark",
              type: "text",
              value: ""
            },
            {
              label: "fiercely_competative_benchmark",
              placeholder: "Enter Fiercely Competitive",
              name: "fiercely_competative_benchmark",
              type: "text",
              value: ""
            }
          ]
        },
        {
          label: "Net Profit per Sales",
          name: "avg_net_profit_per_sales",
          type: "text",
          reletedField: [
            {
              label: "high_competative_advantage_benchmark",
              placeholder: "Enter High competitive Adv.",
              name: "high_competative_advantage_benchmark",
              type: "text",
              value: ""
            },
            {
              label: "some_competative_advantage_benchmark",
              placeholder: "Enter Some Competitive Adv.",
              name: "some_competative_advantage_benchmark",
              type: "text",
              value: ""
            },
            {
              label: "highly_competative_benchmark",
              placeholder: "Enter Highly Competitive",
              name: "highly_competative_benchmark",
              type: "text",
              value: ""
            },
            {
              label: "fiercely_competative_benchmark",
              placeholder: "Enter Fiercely Competitive",
              name: "fiercely_competative_benchmark",
              type: "text",
              value: ""
            }
          ]
        },
        {
          label: "EPS Change",
          name: "number_of_time_sign_change_eps",
          type: "text",
          reletedField: [
            {
              label: "high_competative_advantage_benchmark",
              placeholder: "Enter High competitive Adv.",
              name: "high_competative_advantage_benchmark",
              type: "text",
              value: ""
            },
            {
              label: "some_competative_advantage_benchmark",
              placeholder: "Enter Some Competitive Adv.",
              name: "some_competative_advantage_benchmark",
              type: "text",
              value: ""
            },
            {
              label: "highly_competative_benchmark",
              placeholder: "Enter Highly Competitive",
              name: "highly_competative_benchmark",
              type: "text",
              value: ""
            },
            {
              label: "fiercely_competative_benchmark",
              placeholder: "Enter Fiercely Competitive",
              name: "fiercely_competative_benchmark",
              type: "text",
              value: ""
            }
          ]
        },
        {
          label: "Cash EPS Change",
          name: "number_of_time_sign_change_cash_eps",
          type: "text",
          reletedField: [
            {
              label: "high_competative_advantage_benchmark",
              placeholder: "Enter High competitive Adv.",
              name: "high_competative_advantage_benchmark",
              type: "text",
              value: ""
            },
            {
              label: "some_competative_advantage_benchmark",
              placeholder: "Enter Some Competitive Adv.",
              name: "some_competative_advantage_benchmark",
              type: "text",
              value: ""
            },
            {
              label: "highly_competative_benchmark",
              placeholder: "Enter Highly Competitive",
              name: "highly_competative_benchmark",
              type: "text",
              value: ""
            },
            {
              label: "fiercely_competative_benchmark",
              placeholder: "Enter Fiercely Competitive",
              name: "fiercely_competative_benchmark",
              type: "text",
              value: ""
            }
          ]
        }
      ],
      formData: {},
      errors: [],
      defaultSrc: ""
    };
  },
  methods: {
    setData() {
      this.fields = [
        {
          label: "EBITDA per Sales",
          name: "avg_ebitDA_per_sales",
          type: "text",
          reletedField: [
            {
              label: "High Competitive Adv.",
              placeholder: "Enter High Competitive Adv.",
              name: "avg_ebitDA_per_sales_high_competative_advantage_benchmark",
              type: "text",
              value: this.globalData
                .avg_ebitDA_per_sales_high_competative_advantage_benchmark
                ? this.globalData
                    .avg_ebitDA_per_sales_high_competative_advantage_benchmark
                : ""
            },
            {
              label: "Some Competitive Adv.",
              placeholder: "Enter Some Competitive Adv.",
              name: "avg_ebitDA_per_sales_some_competative_advantage_benchmark",
              type: "text",
              value: this.globalData
                .avg_ebitDA_per_sales_some_competative_advantage_benchmark
                ? this.globalData
                    .avg_ebitDA_per_sales_some_competative_advantage_benchmark
                : ""
            },
            {
              label: "Highly Competitive",
              placeholder: "Enter Highly Competitive ",
              name: "avg_ebitDA_per_sales_highly_competative_benchmark",
              type: "text",
              value: this.globalData
                .avg_ebitDA_per_sales_highly_competative_benchmark
                ? this.globalData
                    .avg_ebitDA_per_sales_highly_competative_benchmark
                : ""
            },
            {
              label: "Fiercely Competitive",
              placeholder: "Enter Fiercely Competitive",
              name: "avg_ebitDA_per_sales_fiercely_competative_benchmark",
              type: "text",
              value: this.globalData
                .avg_ebitDA_per_sales_fiercely_competative_benchmark
                ? this.globalData
                    .avg_ebitDA_per_sales_fiercely_competative_benchmark
                : ""
            }
          ]
        },
        {
          label: "Research and Development costs per Sales",
          name: "avg_research_development_costs_per_sales",
          type: "text",
          reletedField: [
            {
              label: "high_competative_advantage_benchmark",
              placeholder: "Enter High competitive Adv.",
              name:
                "avg_research_development_costs_per_sales_high_competative_advantage_benchmark",
              type: "text",
              value: this.globalData
                .avg_research_development_costs_per_sales_high_competative_advantage_benchmark
                ? this.globalData
                    .avg_research_development_costs_per_sales_high_competative_advantage_benchmark
                : ""
            },
            {
              label: "some_competative_advantage_benchmark",
              placeholder: "Enter Some Competitive Adv.",
              name:
                "avg_research_development_costs_per_sales_some_competative_advantage_benchmark",
              type: "text",
              value: this.globalData
                .avg_research_development_costs_per_sales_some_competative_advantage_benchmark
                ? this.globalData
                    .avg_research_development_costs_per_sales_some_competative_advantage_benchmark
                : ""
            },
            {
              label: "highly_competative_benchmark",
              placeholder: "Enter Highly Competitive",
              name:
                "avg_research_development_costs_per_sales_highly_competative_benchmark",
              type: "text",
              value: this.globalData
                .avg_research_development_costs_per_sales_highly_competative_benchmark
                ? this.globalData
                    .avg_research_development_costs_per_sales_highly_competative_benchmark
                : ""
            },
            {
              label: "fiercely_competative_benchmark",
              placeholder: "Enter Fiercely Competitive",
              name:
                "avg_research_development_costs_per_sales_fiercely_competative_benchmark",
              type: "text",
              value: this.globalData
                .avg_research_development_costs_per_sales_fiercely_competative_benchmark
                ? this.globalData
                    .avg_research_development_costs_per_sales_fiercely_competative_benchmark
                : ""
            }
          ]
        },
        {
          label: "Interest per Sales",
          name: "avg_interest_per_sales",
          type: "text",
          reletedField: [
            {
              label: "high_competative_advantage_benchmark",
              placeholder: "Enter High competitive Adv.",
              name:
                "avg_interest_per_sales_high_competative_advantage_benchmark",
              type: "text",
              value: this.globalData
                .avg_interest_per_sales_high_competative_advantage_benchmark
                ? this.globalData
                    .avg_interest_per_sales_high_competative_advantage_benchmark
                : ""
            },
            {
              label: "some_competative_advantage_benchmark",
              placeholder: "Enter Some Competitive Adv.",
              name:
                "avg_interest_per_sales_some_competative_advantage_benchmark",
              type: "text",
              value: this.globalData
                .avg_interest_per_sales_some_competative_advantage_benchmark
                ? this.globalData
                    .avg_interest_per_sales_some_competative_advantage_benchmark
                : ""
            },
            {
              label: "highly_competative_benchmark",
              placeholder: "Enter Highly Competitive",
              name: "avg_interest_per_sales_highly_competative_benchmark",
              type: "text",
              value: this.globalData
                .avg_interest_per_sales_highly_competative_benchmark
                ? this.globalData
                    .avg_interest_per_sales_highly_competative_benchmark
                : ""
            },
            {
              label: "fiercely_competative_benchmark",
              placeholder: "Enter Fiercely Competitive",
              name: "avg_interest_per_sales_fiercely_competative_benchmark",
              type: "text",
              value: this.globalData
                .avg_interest_per_sales_fiercely_competative_benchmark
                ? this.globalData
                    .avg_interest_per_sales_fiercely_competative_benchmark
                : ""
            }
          ]
        },
        {
          label: "Depreciation per Sales",
          name: "avg_depreciation_per_sales",
          type: "text",
          reletedField: [
            {
              label: "high_competative_advantage_benchmark",
              placeholder: "Enter High competitive Adv.",
              name:
                "avg_depreciation_per_sales_high_competative_advantage_benchmark",
              type: "text",
              value: this.globalData
                .avg_depreciation_per_sales_high_competative_advantage_benchmark
                ? this.globalData
                    .avg_depreciation_per_sales_high_competative_advantage_benchmark
                : ""
            },
            {
              label: "some_competative_advantage_benchmark",
              placeholder: "Enter Some Competitive Adv.",
              name:
                "avg_depreciation_per_sales_some_competative_advantage_benchmark",
              type: "text",
              value: this.globalData
                .avg_depreciation_per_sales_some_competative_advantage_benchmark
                ? this.globalData
                    .avg_depreciation_per_sales_some_competative_advantage_benchmark
                : ""
            },
            {
              label: "highly_competative_benchmark",
              placeholder: "Enter Highly Competitive",
              name: "avg_depreciation_per_sales_highly_competative_benchmark",
              type: "text",
              value: this.globalData
                .avg_depreciation_per_sales_highly_competative_benchmark
                ? this.globalData
                    .avg_depreciation_per_sales_highly_competative_benchmark
                : ""
            },
            {
              label: "fiercely_competative_benchmark",
              placeholder: "Enter Fiercely Competitive",
              name: "avg_depreciation_per_sales_fiercely_competative_benchmark",
              type: "text",
              value: this.globalData
                .avg_depreciation_per_sales_fiercely_competative_benchmark
                ? this.globalData
                    .avg_depreciation_per_sales_fiercely_competative_benchmark
                : ""
            }
          ]
        },
        {
          label: "Selling and Administration per Sales",
          name: "avg_selling_n_administration_per_ns",
          type: "text",
          reletedField: [
            {
              label: "high_competative_advantage_benchmark",
              placeholder: "Enter High competitive Adv.",
              name:
                "avg_selling_n_administration_per_ns_high_competative_advantage_benchmark",
              type: "text",
              value: this.globalData
                .avg_selling_n_administration_per_ns_high_competative_advantage_benchmark
                ? this.globalData
                    .avg_selling_n_administration_per_ns_high_competative_advantage_benchmark
                : ""
            },
            {
              label: "some_competative_advantage_benchmark",
              placeholder: "Enter Some Competitive Adv.",
              name:
                "avg_selling_n_administration_per_ns_some_competative_advantage_benchmark",
              type: "text",
              value: this.globalData
                .avg_selling_n_administration_per_ns_some_competative_advantage_benchmark
                ? this.globalData
                    .avg_selling_n_administration_per_ns_some_competative_advantage_benchmark
                : ""
            },
            {
              label: "highly_competative_benchmark",
              placeholder: "Enter Highly Competitive",
              name:
                "avg_selling_n_administration_per_ns_highly_competative_benchmark",
              type: "text",
              value: this.globalData
                .avg_selling_n_administration_per_ns_highly_competative_benchmark
                ? this.globalData
                    .avg_selling_n_administration_per_ns_highly_competative_benchmark
                : ""
            },
            {
              label: "fiercely_competative_benchmark",
              placeholder: "Enter Fiercely Competitive",
              name:
                "avg_selling_n_administration_per_ns_fiercely_competative_benchmark",
              type: "text",
              value: this.globalData
                .avg_selling_n_administration_per_ns_fiercely_competative_benchmark
                ? this.globalData
                    .avg_selling_n_administration_per_ns_fiercely_competative_benchmark
                : ""
            }
          ]
        },
        {
          label: "Capex per Net Profit",
          name: "avg_capex_per_net_profit",
          type: "text",
          reletedField: [
            {
              label: "high_competative_advantage_benchmark",
              placeholder: "Enter High competitive Adv.",
              name:
                "avg_capex_per_net_profit_high_competative_advantage_benchmark",
              type: "text",
              value: this.globalData
                .avg_capex_per_net_profit_high_competative_advantage_benchmark
                ? this.globalData
                    .avg_capex_per_net_profit_high_competative_advantage_benchmark
                : ""
            },
            {
              label: "some_competative_advantage_benchmark",
              placeholder: "Enter Some Competitive Adv.",
              name:
                "avg_capex_per_net_profit_some_competative_advantage_benchmark",
              type: "text",
              value: this.globalData
                .avg_capex_per_net_profit_some_competative_advantage_benchmark
                ? this.globalData
                    .avg_capex_per_net_profit_some_competative_advantage_benchmark
                : ""
            },
            {
              label: "highly_competative_benchmark",
              placeholder: "Enter Highly Competitive",
              name: "avg_capex_per_net_profit_highly_competative_benchmark",
              type: "text",
              value: this.globalData
                .avg_capex_per_net_profit_highly_competative_benchmark
                ? this.globalData
                    .avg_capex_per_net_profit_highly_competative_benchmark
                : ""
            },
            {
              label: "fiercely_competative_benchmark",
              placeholder: "Enter Fiercely Competitive",
              name: "avg_capex_per_net_profit_fiercely_competative_benchmark",
              type: "text",
              value: this.globalData
                .avg_capex_per_net_profit_fiercely_competative_benchmark
                ? this.globalData
                    .avg_capex_per_net_profit_fiercely_competative_benchmark
                : ""
            }
          ]
        },
        {
          label: "Net Profit per Sales",
          name: "avg_net_profit_per_sales",
          type: "text",
          reletedField: [
            {
              label: "high_competative_advantage_benchmark",
              placeholder: "Enter High competitive Adv.",
              name:
                "avg_net_profit_per_sales_high_competative_advantage_benchmark",
              type: "text",
              value: this.globalData
                .avg_net_profit_per_sales_high_competative_advantage_benchmark
                ? this.globalData
                    .avg_net_profit_per_sales_high_competative_advantage_benchmark
                : ""
            },
            {
              label: "some_competative_advantage_benchmark",
              placeholder: "Enter Some Competitive Adv.",
              name:
                "avg_net_profit_per_sales_some_competative_advantage_benchmark",
              type: "text",
              value: this.globalData
                .avg_net_profit_per_sales_some_competative_advantage_benchmark
                ? this.globalData
                    .avg_net_profit_per_sales_some_competative_advantage_benchmark
                : ""
            },
            {
              label: "highly_competative_benchmark",
              placeholder: "Enter Highly Competitive",
              name: "avg_net_profit_per_sales_highly_competative_benchmark",
              type: "text",
              value: this.globalData
                .avg_net_profit_per_sales_highly_competative_benchmark
                ? this.globalData
                    .avg_net_profit_per_sales_highly_competative_benchmark
                : ""
            },
            {
              label: "fiercely_competative_benchmark",
              placeholder: "Enter Fiercely Competitive",
              name: "avg_net_profit_per_sales_fiercely_competative_benchmark",
              type: "text",
              value: this.globalData
                .avg_net_profit_per_sales_fiercely_competative_benchmark
                ? this.globalData
                    .avg_net_profit_per_sales_fiercely_competative_benchmark
                : ""
            }
          ]
        },
        {
          label: "EPS Change",
          name: "number_of_time_sign_change_eps",
          type: "text",
          reletedField: [
            {
              label: "high_competative_advantage_benchmark",
              placeholder: "Enter High competitive Adv.",
              name:
                "number_of_time_sign_change_eps_high_competative_advantage_benchmark",
              type: "text",
              value: this.globalData
                .number_of_time_sign_change_eps_high_competative_advantage_benchmark
                ? this.globalData
                    .number_of_time_sign_change_eps_high_competative_advantage_benchmark
                : ""
            },
            {
              label: "some_competative_advantage_benchmark",
              placeholder: "Enter Some Competitive Adv.",
              name:
                "number_of_time_sign_change_eps_some_competative_advantage_benchmark",
              type: "text",
              value: this.globalData
                .number_of_time_sign_change_eps_some_competative_advantage_benchmark
                ? this.globalData
                    .number_of_time_sign_change_eps_some_competative_advantage_benchmark
                : ""
            },
            {
              label: "highly_competative_benchmark",
              placeholder: "Enter Highly Competitive",
              name:
                "number_of_time_sign_change_eps_highly_competative_benchmark",
              type: "text",
              value: this.globalData
                .number_of_time_sign_change_eps_highly_competative_benchmark
                ? this.globalData
                    .number_of_time_sign_change_eps_highly_competative_benchmark
                : ""
            },
            {
              label: "fiercely_competative_benchmark",
              placeholder: "Enter Fiercely Competitive",
              name:
                "number_of_time_sign_change_eps_fiercely_competative_benchmark",
              type: "text",
              value: this.globalData
                .number_of_time_sign_change_eps_fiercely_competative_benchmark
                ? this.globalData
                    .number_of_time_sign_change_eps_fiercely_competative_benchmark
                : ""
            }
          ]
        },
        {
          label: "Cash EPS Change",
          name: "number_of_time_sign_change_cash_eps",
          type: "text",
          reletedField: [
            {
              label: "high_competative_advantage_benchmark",
              placeholder: "Enter High competitive Adv.",
              name:
                "number_of_time_sign_change_cash_eps_high_competative_advantage_benchmark",
              type: "text",
              value: this.globalData
                .number_of_time_sign_change_eps_high_competative_advantage_benchmark
                ? this.globalData
                    .number_of_time_sign_change_eps_high_competative_advantage_benchmark
                : ""
            },
            {
              label: "some_competative_advantage_benchmark",
              placeholder: "Enter Some Competitive Adv.",
              name:
                "number_of_time_sign_change_cash_eps_some_competative_advantage_benchmark",
              type: "text",
              value: this.globalData
                .number_of_time_sign_change_cash_eps_some_competative_advantage_benchmark
                ? this.globalData
                    .number_of_time_sign_change_cash_eps_some_competative_advantage_benchmark
                : ""
            },
            {
              label: "highly_competative_benchmark",
              placeholder: "Enter Highly Competitive",
              name:
                "number_of_time_sign_change_cash_eps_highly_competative_benchmark",
              type: "text",
              value: this.globalData
                .number_of_time_sign_change_cash_eps_highly_competative_benchmark
                ? this.globalData
                    .number_of_time_sign_change_cash_eps_highly_competative_benchmark
                : ""
            },
            {
              label: "fiercely_competative_benchmark",
              placeholder: "Enter Fiercely Competitive",
              name:
                "number_of_time_sign_change_cash_eps_fiercely_competative_benchmark",
              type: "text",
              value: this.globalData
                .number_of_time_sign_change_cash_eps_fiercely_competative_benchmark
                ? this.globalData
                    .number_of_time_sign_change_cash_eps_fiercely_competative_benchmark
                : ""
            }
          ]
        }
      ];
      console.log(this.globalData);
      console.log("Set Value ", this.fields);
    },
    cancel(d) {
      console.log("Cancel =>", d);
    },
    submitForm() {
      console.log("submitpin entered");
      // this.validatePin(pin);
      this.submitCBForm();
    },
    showSmallModal() {
      this.$refs.smallModal.open();
    },
    save() {
      console.log(this.globalData, this.formData);
      this.formData["update"] = 0;
      console.log(this.globalData, this.formData);
      this.$refs.smallModal.open();
    },
    update() {
      this.formData["update"] = 1;
      this.$refs.smallModal.open();
    },
    getFormData() {
      let myself = this;
      this.globalData = {};
      http.get("list/benchmarkCompetativeness", {}, (error, response) => {
        if (response.data.length > 0) this.globalData = response.data[0];
        console.log("GlobalDATA", this.globalData);
        for (var i in response.data[0]) {
          console.log("Callback i", i);
          myself[i] = response.data[0][i];
          // myself.globalData = callback.data[0];
          //TODO:: add company updates into our array in future
        }
        myself.setData();
        myself.setFormData();
        console.log("myself", this.globalData);
      });
    },
    setFormData() {
      console.log("SET Form");
      this.formData = {};
      for (var index in this.fields) {
        let field = this.fields[index];
        if (!field.placeholder) field.placeholder = "";
        if (!field.value) field.value = "";
        if (!field.help) field.help = "";
        // this.$set(this.formData, field.name, field.value);
        if (field.reletedField.length > 0) {
          let relatedData = field.reletedField;
          for (var ind in relatedData) {
            let field1 = relatedData[ind];
            if (!field1.placeholder) field1.placeholder = "";
            if (!field1.value) field1.value = "";
            if (!field1.type) field1.type = "";
            this.$set(this.formData, field1.name, field1.value, field1.type);
          }
        }
      }
      console.log("this.formData", this.formData);
    },
    submitCBForm: function(formData) {
      let myself = this;
      console.log("submit form", this.formData);
      http.post(
        "update/benchmarkCompetativeness",
        this.formData,
        (error, callback) => {
          // myself.$router.push({ name: "settings" });
          //TODO:: add company updates into our array in future
          this.$toastr.success("Data updated successfully!", "", {});
        }
      );
    }
  }
};
</script>
<style>
form .col-md-3 {
  width: 40%;
}
</style>



// WEBPACK FOOTER //
// src/views/manual-forms/competitvenessBenchmark.vue